import {
  Box,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import _ from 'lodash';


export default function AxlTable({
  fields = [],
  page = 1,
  result = {
    page: 0,
    count: 0,
    size: 10,
    items: [],
  },
  isPagination = true,
  rerender = [],
  onChange = () => {/* empty */},
}) {
  const theme = useTheme();

  return (
    <>
      <TableContainer component={Box}>
        <Table>
          <TableHead sx={{ backgroundColor: theme.palette.primary.main }}>
            <TableRow>
              {fields.map((field, idx) => (
                <TableCell key={`field-${idx}`} sx={{ color: theme.palette.primary.contrastText }}>{_.get(field, 'label', '-')}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {!!result.items.length &&
              result.items.map((item, x) => (
                <TableRow key={`row-${x}`}>
                  {fields.map((field, y) => {
                    return (
                      <TableCell key={`field-${x}-${y}`} component="th" scope="row">
                        {!rerender[field.name] ? _.defaultTo(item[field.name], '-') : rerender[field.name](item[field.name], item, result)}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      {isPagination && (() => {
        const currentPage = page || 1;
        const size = Number(result.size) || 0;
        const count = Number(result.count) || 0;
        const pages = size <= 0 ? Math.max(1, count > 0 ? count : 1) : Math.ceil(count / size);
        return (
          <Box py={1} display="flex" justifyContent="center">
            <Pagination count={pages} page={currentPage} onChange={(e, newPage) => currentPage !== newPage && onChange(newPage)} color="primary" size="small" />
          </Box>
        );
      })()}
    </>
  );
}
